// extracted by mini-css-extract-plugin
export var dividerLine = "_bl-3";
export var itemImage = "_bl-9";
export var lightDivider = "_bl-4";
export var modalContent = "_bl-5";
export var modalContentCompact = "_bl-6";
export var productCard = "_bl-a";
export var productImage = "_bl-b";
export var productImageCompact = "_bl-7";
export var productImagePlaceholder = "_bl-c";
export var productImagePlaceholderCompact = "_bl-8";
export var progressBarBackground = "_bl-1";
export var progressBarContainer = "_bl-0";
export var progressBarFill = "_bl-2";